/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import {
  Form as FormUi,
  Container,
  TextArea,
  Button,
  Input,
  Segment,
  Dropdown,
  Icon,
  Search,
} from "semantic-ui-react";
import "react-datepicker/dist/react-datepicker.css";
import InsertJobOrders from "./insertOrder";
// import InsertDocument from "./documentdetail";
import { DateData } from "../dynamicComponent/datepick";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import { connect } from "react-redux";
import SearchDropdown from "./searchDropdown";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import ReadAxios from "../axiosComponent/read";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import { translate } from "react-i18next";
// TODO: make call from redux
import { min, isEmpty } from "lodash";
import MandatoryMark from "../common/mandatorymark";
import ModalDiscardOrder from "./orderDiscardConfirmation";
import ModalCreateRoute from "./modalCreateRoute";
import FileCreatAxios from "../axiosComponent/fileupload";
import { YYYYMMDDHHmmss } from "../../utils/constant";

const InsertShipment = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  shipmentEdit,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  props
}) => {
  const customerNo = localStorage.getItem('customerNumber')
  const [deleteModal, setdeleteModal] = useState(false);
  const [submitDissable, setsubmitDissable] = useState(false);
  const [movementType, setmovementType] = useState(customerNo != 1122 ? "primary" : "import");
  const [disable, setmovementTypedisable] = useState(false);
  const [shipmentdata, setShipment] = useState({});

  useEffect(() => {
    setFieldValue('required_on', new Date())
    setFieldValue('shipment_reference_no', null)
    if (Number(localStorage.getItem("customerNumber")) == 1158 || Number(localStorage.getItem("customerNumber")) == 1123) {
      setmovementTypedisable(true);
    }
  }, [])
  const setSourceDestination = async (name, value) => {
    if (value) {
      const { key, raw } = value;
      if (raw?.routeMasterId) {
        setFieldValue("routeCodeSelect", raw.routeMasterId);
        let checkPointsArray = await ReadAxios({
          url: `routeManager/${raw?.routeMasterId}`,
        });

        checkPointsArray = isEmpty(checkPointsArray)
          ? []
          : checkPointsArray.data.resultSet;
        setFieldValue(name, key);
        setFieldValue("source", checkPointsArray?.[0]?.checkPointName);
        setFieldValue(
          "destination",
          checkPointsArray?.[checkPointsArray.length - 1]?.checkPointName
        );
        setFieldValue("budgeted_kms", checkPointsArray?.[0]?.budgetedKms);
        setFieldValue(
          "budgeted_time",
          checkPointsArray?.[checkPointsArray.length - 1]?.budgetedTime
        );

      }
    } else {
      setFieldValue(name, value);
      setFieldValue("source", "");
      setFieldValue("destination", "");
      setFieldValue("budgeted_kms", null);
      setFieldValue("budgeted_time", null);
    }
  };

  const checkForOrder = (name, data) => {
    setmovementType(data.value);
    if (
      shipment &&
      shipment.create &&
      shipment.create.orders &&
      shipment.create.orders.length > 0
    ) {
      setdeleteModal(true);
    } else {
      setFieldValue("movement_type", data.value);
    }
  };

  let handleFileUpload = (event) => {
    // this.setState({useravtar: event.currentTarget.files[0]})
  };

  const handleDeleteSubmit = () => {
    deleteAllOrderDispatcher();
    setdeleteModal(false);
    setFieldValue("movement_type", movementType);
  };

  const handleDeleteClose = () => {
    setdeleteModal(false);
  };

  const setFileData = (fileType, data, deliveryIndex) => {
    if (fileType === 'Other LR') {
      data.deliveryIndex = deliveryIndex
      let fileData = values.otherLRFile
      fileData.push(data)
      setFieldValue("otherLRFile", fileData);
    } else if (fileType === 'Physical LR') {
      data.deliveryIndex = deliveryIndex

      let fileData = values.LRFile
      fileData.push(data)
      setFieldValue("LRFile", fileData);
    }
  };

  const setFileDataInvoice = (fileType, data, deliveryIndex, invoiceIndex) => {
    if (fileType === 'Invoice Copy') {
      data.invoiceIndex = invoiceIndex
      data.deliveryIndex = deliveryIndex
      let fileData = values.InvoicesFile

      fileData.push(data)
      setFieldValue("InvoicesFile", fileData);
    } else if (fileType === 'Eway Bill Copy') {
      data.invoiceIndex = invoiceIndex
      data.deliveryIndex = deliveryIndex
      let fileData = values.EwaybillFile
      fileData.push(data)
      setFieldValue("EwaybillFile", fileData);
    }
  }

  return (
    <React.Fragment>
      <Formiker>
        <Segment>
          <div className="ui form tiny p-bold-600">
            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.movement_type.title") || "Movement Type"}{" "}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.movement_type && errors.movement_type ? true : false
                }
              >
                <Dropdown
                  name="movement_type"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  disabled={disable}
                  selection
                  placeholder={
                    t("shipment_form.movement_type.placeholder") ||
                    "Movement Type"
                  }
                  onChange={(name, data) => checkForOrder(name, data)}
                  options={localStorage.getItem("customerNumber") == 1122 ? [
                    { key: "2", text: "Import", value: "import" },
                    { key: "1", text: "Export", value: "export" },
                  ]
                    :
                    [
                      { key: "2", text: "Import", value: "import" },
                      { key: "3", text: "Primary", value: "primary" },
                      { key: "1", text: "Export", value: "export" },
                      { key: "4", text: "Secondary", value: "secondary" },
                    ]
                  }
                  value={values.movement_type}
                />
                {touched.movement_type && errors.movement_type ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.movement_type.error_msg.${errors.movement_type}`
                    ) || errors.movement_type}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {t("shipment_form.estimate_clearence_date.title") || "Estimated Clearance End Date"}{""}
                      <MandatoryMark />
                    </>
                  ) : (
                    <>
                      {t("shipment_form.required_on.title") || "Required On"}{" "}
                      <MandatoryMark />
                    </>
                  )}

                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.required_on && errors.required_on ? true : false}
                className="datepic"
              >
                <DateData
                  name="required_on"
                  autoComplete="off"
                  showTimeSelect
                  timeFormat="HH:mm"
                  popperClassName="dateTime"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeIntervals={5}
                  customInput={
                    <Input
                      icon="time"
                      // className="dateWidth"
                      iconPosition="left"
                    />
                  }
                />
                {touched.required_on && errors.required_on ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.required_on.error_msg.${errors.required_on}`
                    ) || errors.required_on}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.route_code.title") || "Route"}{" "}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.route_code && errors.route_code ? true : false}
              >
                <div className="ui action input">
                  <SearchDropdown
                    setField={setSourceDestination}
                    masterRoute="routeMaster"
                    masterRouteKey="routeCode"
                    masterRouteName="routeName"
                    fieldName="route_code"
                    deafultValue={values.route_name}
                  />
                  <div className="modal-create-route"><ModalCreateRoute /></div>
                </div>
                {touched.route_code && errors.route_code ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.route_code.error_msg.${errors.route_code}`
                    ) || errors.route_code}
                  </div>
                ) : null}
              </FormUi.Field>

              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {t("shipment_form.number_of_containers.title") || " No. of Containers"}{" "}
                      <MandatoryMark />
                    </>
                  ) : (
                    <>
                      {t("shipment_form.number_of_vehicles.title") ||
                        "Number Of Vehicles"}{" "}
                      <MandatoryMark />
                    </>
                  )}

                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={
                  touched.no_of_vehicles && errors.no_of_vehicles ? true : false
                }
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="no_of_vehicles"
                  type="number"
                  min={0}
                />
                {touched.no_of_vehicles && errors.no_of_vehicles ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.number_of_vehicles.error_msg.${errors.no_of_vehicles}`
                    ) || errors.no_of_vehicles}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "import" ? (
                    <>
                      {t("shipment_form.pickup_location.title") || "Pickup Location"}{" "}
                      <MandatoryMark />
                    </>
                  ) : (
                    <>
                      {values.movement_type == "export" ? (
                        <>
                          {t("shipment_form.pickup_location_e.title") || "Pickup Location"}{" "}
                          <MandatoryMark />
                        </>
                      ) : (
                        <>
                          {t("shipment_form.source.title") || "Source"}{" "}
                          <MandatoryMark />
                        </>
                      )}

                    </>
                  )}

                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.source && errors.source ? true : false}
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="source"
                  value={values.source}
                  readOnly
                />
                {touched.source && errors.source ? (
                  <div className="w3-small w3-text-red">
                    {t(`shipment_form.source.error_msg.${errors.source}`) ||
                      errors.source}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {values.movement_type == "primary" ? (
                    <>
                      {t("shipment_form.destination_d.title") || "Destination"}{" "}
                    </>
                  ) : (
                    <>
                      {values.movement_type == "export" ? (
                        <>
                          {t("shipment_form.destination_e.title") || "Destination"}{" "}
                        </>
                      ) : (
                        <>
                          {t("shipment_form.destination.title") || "Destination"}{" "}
                        </>
                      )}
                    </>
                  )}
                  <MandatoryMark />
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.destination && errors.destination ? true : false}
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="destination"
                  value={values.destination}
                  readOnly
                />
                {touched.destination && errors.destination ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.destination.error_msg.${errors.destination}`
                    ) || errors.destination}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group>
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.budgetedKms.title") || "Source"}{" "}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.budgeted_kms && errors.budgeted_kms ? true : false}
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="budgeted_kms"
                  type="number"
                  value={values.budgeted_kms}
                // readOnly
                />
                {touched.budgeted_kms && errors.budgeted_kms ? (
                  <div className="w3-small w3-text-red">
                    {t(`shipment_form.budgetedKms.error_msg.${errors.budgeted_kms}`) ||
                      errors.budgeted_kms}
                  </div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width={1} />
              <FormUi.Field width={3}>
                <label className="labelName mt-2">
                  {t("shipment_form.budgetedtime.title") || "Destination"}{" "}
                </label>
              </FormUi.Field>
              <FormUi.Field
                width={4}
                error={touched.budgeted_time && errors.budgeted_time ? true : false}
              >
                <Fieldmik
                  component={MyNormalInput}
                  name="budgeted_time"
                  type="number"
                  value={values.budgeted_time}
                // readOnly
                />
                {touched.budgeted_time && errors.budgeted_time ? (
                  <div className="w3-small w3-text-red">
                    {t(
                      `shipment_form.budgetedtime.error_msg.${errors.budgeted_time}`
                    ) || errors.budgeted_time}
                  </div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>

            <FormUi.Group>
              <FormUi.Field width={1} />
            </FormUi.Group>
          </div>
        </Segment>
        <InsertJobOrders handleSubmit={handleSubmit} mode={mode} moment={values.movement_type == "import" ? 'import' : values.movement_type == "export" ? 'export' : 'primary'} reqon={values.required_on} btime={values.budgeted_time} bdistance={values.budgeted_kms} values={values} vihicle={vehicleTypeMaster} rcode={values.routeCodeSelect} setFileDataLR={setFileData} setFileDataInvoices={setFileDataInvoice} />

        <ModalDiscardOrder
          OpenModel={deleteModal}
          handleDeleteClose={handleDeleteClose}
          handleDeleteSubmit={handleDeleteSubmit}
        />
        {shipment &&
          shipment.create &&
          shipment.create.orders &&
          shipment.create.orders.length > 0 && (
            <Container className="p-3">
              <div className="row p-center">
                <div className="m-2">
                  <Button
                    id="save-order"
                    type="button"
                    size="mini"
                    // disabled={isSubmitting}
                    className="w3-blue w3-round w3-hover-blue"
                    onClick={() => handleSubmit()}
                  >
                    {t("action_button.save") || "Save"}
                  </Button>
                </div>
              </div>
            </Container>
          )}
      </Formiker>
    </React.Fragment>
  );
};

const FormikShipment = withFormik({
  enableReinitialize: false,
  validationSchema: yup.object({
    shipment_reference_no: yup
      .string()
      .optional().nullable(),
    import_declaration_no: yup
      .string()
      .optional().nullable(),
    boarding_no: yup
      .string()
      .optional().nullable(),
    required_on: yup.date().required("required"),
    route_code: yup.string().required("required"),
    // proposed_vehicle_type: yup.number().required("required"),
    source: yup.string().required("required"),
    destination: yup.string().required("required"),
    no_of_vehicles: yup.number().required("required").min(1, "min"),
    movement_type: yup.string().required("required"),
    budgeted_kms: yup
      .number()
      .optional().nullable(),
    budgeted_time: yup
      .number()
      .optional().nullable(),
    // base_rate: yup.number().optional().nullable(),
    remarks: yup.string().optional().min(5, "min").max(200, "max"),
  }),
  // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
  mapPropsToValues: (props) => (
    {
      shipment_reference_no: (props.shipmentEdit ? props.shipmentEdit.shipment_reference_no : ""),
      required_on: (props.shipmentEdit ? props.shipmentEdit.required_on : ""),
      route_code: (props.shipmentEdit ? props.shipmentEdit.orders[0].shipment.route_code : ""),
      route_name: (props.shipmentEdit ? props.shipmentEdit.orders[0].shipment.route_name : ""),
      import_declaration_no: (props.shipmentEdit ? props.shipmentEdit.import_declaration_no : ""),
      boarding_no: (props.shipmentEdit ? props.shipmentEdit.boarding_no : ""),
      // proposed_vehicle_type: props.proposed_vehicle_type || "",
      source: (props.shipmentEdit ? props.shipmentEdit.route_details.source : ""),
      destination: (props.shipmentEdit ? props.shipmentEdit.route_details.destination : ""),
      budgeted_kms: (props.shipmentEdit ? props.shipmentEdit.route_details.budgetedKms : 0),
      budgeted_time: (props.shipmentEdit ? props.shipmentEdit.route_details.budgetedTime : 0),
      routeCodeSelect: (props.shipmentEdit ? props.shipmentEdit.route_details.routeMasterId : 0),
      no_of_vehicles: (props.shipmentEdit ? props.shipmentEdit.no_of_vehicles : 1),
      movement_type: (props.shipmentEdit ? props.shipmentEdit.movement_type : localStorage.getItem("customerNumber") != 1122 ? "primary" : "import"),
      otherLRFile: [],
      LRFile: [],
      InvoicesFile: [],
      EwaybillFile: [],
      // base_rate: props.base_rate, // Optional params should only be send to API if they contain some value.
      // remarks: props.shipmentEdit.remarks, // Optional params should only be send to API if they contain some value.
    }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {
    let save_order_btn = document.getElementById("save-order");
    save_order_btn.disabled = true;
    if (values.import_declaration_no == "") {
      values.import_declaration_no = null
    }
    if (values.boarding_no == "") {
      values.boarding_no = null
    }
    if (values.movement_type == 'primary') {
      values.boarding_no = null;
      values.import_declaration_no = null;
    }
    let storeShipment = props.shipment
      ? props.shipment.create
        ? props.shipment.create
        : props.shipment
      : {};
    let shipments = Object.assign({}, storeShipment, values);
    props.createShipmentDispatcher(shipments, true);
    // TODO: move this call in redux
    if (
      props.shipment.create &&
      props.shipment.create.orders &&
      props.shipment.create.orders.length > 0
    ) {
      setSubmitting(false);
      let storeShipment = props.shipment
        ? props.shipment.create
          ? props.shipment.create
          : props.shipment
        : {};
      let shipments = Object.assign({}, storeShipment, values);
      props.createShipmentDispatcher(shipments, true);
      let required_on = moment(values.required_on).format(YYYYMMDDHHmmss)
      CreatAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/shipments`,
        payload: { ...shipments, required_on },
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          };
          props.successAlertDispatcher(alert);
          props.onFormSubmit();
          save_order_btn.disabled = false;

          if (values?.otherLRFile?.length > 0) {
            values.otherLRFile.forEach(element => {
              if (res.data.data.data?.orders?.[0]?.deliveries?.[element.deliveryIndex]?.common_delivery_id) {
                this.fileUploadDelivery(element, res.data.data.data.orders[0].deliveries[element.deliveryIndex].common_delivery_id, 'other')
              }
            });
          }


          if (values?.LRFile?.length > 0) {
            values.LRFile.forEach(element => {
              if (res.data.data.data?.orders?.[0]?.deliveries?.[element.deliveryIndex]?.common_delivery_id) {
                setTimeout(() => {
                  this.fileUploadDelivery(element, res.data.data.data.orders[0].deliveries[element.deliveryIndex].common_delivery_id, 'physical_lr_copy')
                }, 1000);
              }
            });
          }


          if (values?.InvoicesFile?.length > 0) {
            values.InvoicesFile.forEach(element => {
              if (res.data.data.data?.orders?.[0]?.deliveries?.[element.deliveryIndex]?.common_delivery_id && res.data.data.data?.orders?.[0].deliveries?.[element.deliveryIndex]?.invoices?.[element.invoiceIndex]?.common_invoice_id) {
                this.fileUploadInvoices(element, res.data.data.data.orders[0].deliveries[element.deliveryIndex].common_delivery_id, res.data.data.data.orders[0].deliveries[element.deliveryIndex]?.invoices?.[element.invoiceIndex]?.common_invoice_id, 'invoice_no')
              }
            });
          }


          if (values?.EwaybillFile?.length > 0) {
            values.EwaybillFile.forEach(element => {
              if (res.data.data.data?.orders?.[0]?.deliveries?.[element.deliveryIndex]?.common_delivery_id && res.data.data.data?.orders?.[0].deliveries?.[element.deliveryIndex]?.invoices?.[element.invoiceIndex]?.common_invoice_id) {
                setTimeout(() => {
                  this.fileUploadInvoices(element, res.data.data.data.orders[0].deliveries[element.deliveryIndex].common_delivery_id, res.data.data.data.orders[0].deliveries[element.deliveryIndex]?.invoices[element.invoiceIndex]?.common_invoice_id, 'eway_bill')
                }, 1000);
              }
            });
          }

        })
        .catch((err) => {
          console.log('check', err);
          if (err?.response?.data?.message) {
            let alert = {
              type: "error",
              messageHeader: "Error",
              messageBody: typeof (err.response.data.message) == "object" ? err.response.data.message[0] : err.response.data.message,
            };
            props.errorAlertDispatcher(alert);
          }

          save_order_btn.disabled = false;
        });
    }

  },

  fileUploadDelivery(file, commonDeliveryId, docType) {
    delete file.deliveryIndex
    let payloadData = {
      file: file,
      doc_type: docType,
      doc_name: file.name
    }
    FileCreatAxios({
      fileUploadURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/delivery/${commonDeliveryId}/delivery_related_lr_documents/upload`,
      payload: { ...payloadData },
    }).then(() => {

    }).catch((err) => {

    })
  },

  fileUploadInvoices(file, commonDeliveryId, invoideId, docType) {
    let payloadData = {
      file: file,
      doc_type: docType
    }
    FileCreatAxios({
      fileUploadURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/invoice/${invoideId}/invoice_documents/upload`,
      payload: { ...payloadData },
    }).then(() => {

    }).catch((err) => {

    })
  }
})(InsertShipment);

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_shipment")(FormikShipment));
